import { del, objectToQueryParams } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  filepath: string;
}

export function useDeleteDocument() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ filepath }: Params) =>
      del({
        url: `/documentation/delete${objectToQueryParams({ filepath })}`,
      }),
    onSuccess: (_, { filepath }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getDocumentationDocs(filepath.split('/')[0] || undefined),
      });
    },
  });

  const deleteDocument = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    deleteDocument,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
